import { render, staticRenderFns } from "./SuperAdmins.vue?vue&type=template&id=269b99a0"
import script from "./SuperAdmins.vue?vue&type=script&lang=js"
export * from "./SuperAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports